module.exports = __webpack_public_path__ + "img/cornell.6ce0abce.png";